<template>
	<div>
		<el-container class="navpage">
			<el-main style="padding: 0 10px;">
				<el-button type="warning" size="mini" icon="el-icon-edit" @click="addLanguage('')">添加语言</el-button>
				<el-button-group>
					<el-button type="primary" size="mini" icon="el-icon-select" @click="selectAll">全选</el-button>
					<el-button type="warning" size="mini" icon="el-icon-select" @click="selectDiff">反选</el-button>
				</el-button-group>
				<el-dropdown trigger="click">
					<el-button type="primary" icon="el-icon-setting" size="mini">
						筛选
						<i class="el-icon-arrow-down el-icon--right"></i>
					</el-button>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item v-for="(items, index) in filtrateList" :key="index">
							<el-dropdown trigger="hover" placement="right-start" @command="seleCommand">
								<el-button type="text" icon="el-icon-caret-right" size="mini">{{ items.label }}</el-button>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item
										icon="el-icon-caret-right"
										v-for="(item, key) in items.seconds"
										:key="key"
										:command="{ indexa: index, indexb: key, param: items.paramValue, paramval: item.val }"
										:class="item.checked ? 'color-blue' : ''"
									>
										{{ item.label }}
									</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				<el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteLanguage">删除</el-button>
				<el-button type="warning" size="mini" icon="el-icon-refresh" @click="languageList()">刷新</el-button>
				<el-dropdown trigger="click">
					<el-button type="success" icon="el-icon-setting" size="mini">
						设置
						<i class="el-icon-arrow-down el-icon--right"></i>
					</el-button>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item v-for="(items, index) in setList" :key="index">
							<el-dropdown trigger="hover" placement="right-start" @command="setCommand">
								<el-button type="text" icon="el-icon-caret-right" size="mini">{{ items.label }}</el-button>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item
										icon="el-icon-caret-right"
										v-for="(item, index) in items.seconds"
										:key="index"
										:command="{ setParam: items.paramValue, setParamVal: item.val }"
									>
										{{ item.label }}
									</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				<el-table
					ref="multipleTable"
					:data="langList"
					style="width: 100%;margin-bottom: 20px;"
					row-key="lan_id"
					:stripe="true"
					:default-sort="{ prop: 'lan_id', order: 'descending' }"
					@sort-change="sortChange"
					@selection-change="selectChange"
					tooltip-effect="dark"
				>
					<el-table-column type="selection" width="55" :selectable="canCheck"></el-table-column>
					<el-table-column prop="lan_id" label="序号" width="80" sortable></el-table-column>
					<el-table-column prop="pid" label="排列号" width="100" sortable></el-table-column>
					<el-table-column prop="lngtitle" label="语言名称" show-overflow-tooltip></el-table-column>
					<el-table-column prop="lng" label="语言标识符" show-overflow-tooltip></el-table-column>
					<el-table-column prop="packname" label="自定义文件夹">
						<template slot-scope="scope">
							<i class="el-icon-close color-red" v-if="!scope.row.packname"></i>
							<span>{{scope.row.packname}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="isopen" label="显示状态">
						<template slot-scope="scope">
							<i class="el-icon-close color-red" v-if="!scope.row.isopen"></i>
							<i class="el-icon-check color-green" v-else></i>
						</template>
					</el-table-column>
					<el-table-column prop="iswap" label="移动端显示状态">
						<template slot-scope="scope">
							<i class="el-icon-close color-red" v-if="!scope.row.iswap"></i>
							<i class="el-icon-check color-green" v-else></i>
						</template>
					</el-table-column>
					<el-table-column prop="ismenu" label="加入语言目录">
						<template slot-scope="scope">
							<i class="el-icon-close color-red" v-if="!scope.row.ismenu"></i>
							<i class="el-icon-check color-green" v-else></i>
						</template>
					</el-table-column>
					<el-table-column label="操作">
						<template slot-scope="scope">
							<el-button type="warning" size="mini" @click="addLanguage(scope.row)">修改</el-button>
						</template>
					</el-table-column>
				</el-table>

				<!-- dialog -->
				<el-dialog title="添加语言" :visible.sync="dialogVisible" width="80%" :close-on-click-modal="false">
					<el-form class="text-left" ref="attrForm" :rules="rules" :model="addScope">
						<el-form-item label="语言标识符" :label-width="formLabelWidth" prop="lng">
							<el-input v-model="addScope.lng" autocomplete="off" placeholder="请输入语言标识符纯英文"></el-input>
						</el-form-item>
						<el-form-item label="语言名称" :label-width="formLabelWidth" prop="lngtitle">
							<el-input v-model="addScope.lngtitle" autocomplete="off" placeholder="请输入语言名称，长度2至10位的任意字符"></el-input>
						</el-form-item>
						<el-form-item label="首页title" :label-width="formLabelWidth" prop="index_title">
							<el-input v-model="addScope.index_title" autocomplete="off" placeholder="请输入首页title"></el-input>
						</el-form-item>
						<el-form-item label="首页keywords" :label-width="formLabelWidth" prop="index_keywords">
							<el-input v-model="addScope.index_keywords" autocomplete="off" placeholder="请输入首页keywords"></el-input>
						</el-form-item>
						<el-form-item label="首页description" :label-width="formLabelWidth" prop="index_description">
							<el-input v-model="addScope.index_description" autocomplete="off" placeholder="请输入首页description"></el-input>
						</el-form-item>
						<el-form-item label="自定义文件夹" :label-width="formLabelWidth" prop="call_type">
							<el-radio-group v-model="addScope.ispack">
								<el-radio :label="1">启用</el-radio>
								<el-radio :label="0">禁用</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item v-if="addScope.ispack" label="文件夹名称" :label-width="formLabelWidth" prop="packname">
							<el-input v-model="addScope.packname" autocomplete="off" placeholder="请输入自定义文件夹名称，长度2至150位的任意字符"></el-input>
						</el-form-item>
					</el-form>

					<div slot="footer" class="dialog-footer">
						<el-button @click="dialogVisible = false">取 消</el-button>
						<el-button type="primary" @click="submitRuleForm('attrForm')">确 定</el-button>
					</div>
				</el-dialog>
			</el-main>
		</el-container>
		<pic-list ref="piclist" @confirm="chooseIconConfirm"></pic-list>
	</div>
</template>
<script>
import Sortable from 'sortablejs';
import picList from '../../components/piclist/piclist.vue';
export default {
	name: '',
	components:{
		picList
	},
	data() {
		return {
			sort_param: '', //排序字段
			sort_type: '', //排序方式ascending = asc;descending = desc,'' = asc;
			langList: [],
			selectedLngIds: [],
			filtrateList: [
				{
					label: '自定义文件夹',
					paramValue: 'ispack',
					seconds: [
						{
							val: '',
							label: '全部',
							checked: true
						},
						{
							val: 1,
							label: '开启'
						},
						{
							val: 0,
							label: '关闭'
						}
					]
				},
				{
					label: '显示状态',
					paramValue: 'isopen',
					seconds: [
						{
							val: '',
							label: '全部',
							checked: true
						},
						{
							val: 1,
							label: '开启'
						},
						{
							val: 0,
							label: '关闭'
						}
					]
				},
				{
					label: '移动端显示状态',
					paramValue: 'iswap',
					seconds: [
						{
							val: '',
							label: '全部',
							checked: true
						},
						{
							val: 1,
							label: '开启'
						},
						{
							val: 0,
							label: '关闭'
						}
					]
				}
			],
			setList: [
				{
					label: '显示状态',
					paramValue: 'isopen',
					seconds: [
						{
							val: 1,
							label: '开启'
						},
						{
							val: 0,
							label: '关闭'
						}
					]
				},
				{
					label: '移动端显示状态',
					paramValue: 'iswap',
					seconds: [
						{
							val: 1,
							label: '开启'
						},
						{
							val: 0,
							label: '关闭'
						}
					]
				},
				{
					label: '加入语言目录',
					paramValue: 'ismenu',
					seconds: [
						{
							val: 1,
							label: '开启'
						},
						{
							val: 0,
							label: '关闭'
						}
					]
				}
			],
			selectParams: [],
			dialogVisible: false,
			addScope: {
				lang:'',
				langtitle:'',
				packname:'',
				ispack:0,
				index_title:'',
				index_keywords:'',
				index_description:''
			},
			formLabelWidth: '120px',
			pictotal:0,
			fileType: ['filename_pic', 'filename_file', 'filename_text'],
			rules: {
				lng: [{ required: true, message: '请输入语言标识符', trigger: 'blur' }, { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }],
				lngtitle: [{ required: true, message: '请输入语言名称', trigger: 'blur' }, { min: 2, max: 10, message: '长度在 2 到 10 个字符', trigger: 'blur' }],
				index_title: [{ required: true, message: '请设置语言首页标题', trigger: 'blur' }, { min: 1, max: 255, message: '长度在 1 到 255 个字符', trigger: 'blur' }],
				index_keywords: [{ required: true, message: '请设置首页关键词', trigger: 'blur' }, { min: 1, max: 255, message: '长度在 1 到 255 个字符', trigger: 'blur' }],
				index_description: [{ required: true, message: '请设置首页简介', trigger: 'blur' }, { min: 1, max: 500, message: '长度在 1到 500 个字符', trigger: 'blur' }],
			},
		};
	},
	mounted() {
		this.languageList(1);
	},
	methods: {
		// 行拖拽排序
		rowDrop(that) {
			// 此时找到的元素是要拖拽元素的父容器
			const tbody = document.querySelector('.el-table__body-wrapper tbody');
			const _this = that;
			Sortable.create(tbody, {
				// 指定父元素下可被拖拽的子元素
				draggable: '.el-table__row',
				onEnd({ newIndex, oldIndex }) {
					const currRow = _this.langList.splice(oldIndex, 1)[0];
					_this.langList.splice(newIndex, 0, currRow);
					console.log('行拖拽结果', 'newIndex:' + newIndex, 'oldIndex:' + oldIndex, 'currRow:', currRow);
					_this.langList.map((item, index) => {
						item.pid = index;
					});
					// 调用后台拖拽排序接口
					if (newIndex != oldIndex) {
						_this._updateMoveData();
					}
				}
			});
		},
		// 拖拽排序接口
		async _updateMoveData() {
			this.$axios({
				url: this.HOST + '/admin.document/updateKefuSort',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token,
					langList: this.langList
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						this.$message.error(res.data.msg);
						if (res.data.admin_err == 'admininfo_error') {
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						console.log('已成功重排序');
					}
				})
				.catch(err => {});
		},
		// 全选
		selectAll() {
			this.langList.map(item => {
				if(!item.lockin){
					this.$refs.multipleTable.toggleRowSelection(item, true); //切换该子节点选中状态
				}
			});
		},
		// 反选
		selectDiff() {
			let diff = [];
			this.langList.map(item => {
				if(!item.lockin){
					if (this.selectedLngIds.indexOf(item.lan_id) != -1) {
						this.$refs.multipleTable.toggleRowSelection(item, false); //切换该子节点选中状态
					} else {
						diff.push(item.lan_id);
						this.$refs.multipleTable.toggleRowSelection(item, true); //切换该子节点选中状态
					}
				}
			});
			this.selectedLngIds = diff;
			console.log(this.selectedLngIds);
		},
		// 删除
		deleteLanguage() {
			if (!this.selectedLngIds.length) {
				this.$message.error('尚未选中任何数据！');
				return false;
			}
			this.$confirm('是否要删除所选数据？此操作一经删除不可恢复！')
				.then(() => {
					this.$axios({
						url: this.HOST + '/admin.setting/deleteLanguage',
						method: 'post',
						data: {
							adminid: JSON.parse(this.$store.state.user.userInfo).id,
							token: JSON.parse(this.$store.state.user.userInfo).token,
							lngIds: this.selectedLngIds
						}
					})
						.then(res => {
							console.log(res.data);
							if (res.data.status == 0) {
								this.$message.error(res.data.msg);
								if (res.data.admin_err == 'admininfo_error') {
									this.exit().then(res => {
										console.log(res);
										if (res.actionStatus == 1) {
											this.$router.push('/login');
										}
									});
								}
							} else {
								this.$message.success(res.data.msg);
								this.languageList();
							}
						})
						.catch(err => {});
				})
				.catch(() => {});
		},
		sortChange({ column, prop, order }) {
			console.log(column, prop, order);
			// this.sort_param = prop;
			// this.sort_type = order == 'descending' ? 'desc' : 'asc';
			// this.languageList();
		},
		seleCommand(command) {
			console.log('sele:', command);
			this.selectParams[command.param] = command.paramval;
			this.filtrateList[command.indexa].seconds.map(item => {
				this.$set(item, 'checked', false);
			});
			this.filtrateList[command.indexa].seconds[command.indexb].checked = true;
			console.log(this.selectParams);
			this.languageList();
		},
		setCommand(command) {
			console.log('set:', command);
			this.setParam = command.setParam;
			this.setParamVal = command.setParamVal;
			this.setLngParam();
		},
		setLngParam() {
			if (!this.selectedLngIds.length) {
				this.$message.error('尚未选中任何语言信息');
				return false;
			}
			this.$axios({
				url: this.HOST + '/admin.setting/setLngParam',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token,
					lngIds: this.selectedLngIds,
					setParam: this.setParam,
					setParamVal: this.setParamVal
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						if (res.data.admin_err == 'admininfo_error') {
							this.$message.error(res.data.msg);
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.langList.map(item => {
							if (this.selectedLngIds.indexOf(item.lan_id) !== -1) {
								item[this.setParam] = this.setParamVal;
							}
						});
						this.$message.success(res.data.msg);
						// this.selectedadIds = []//选中值初始化
					}
				})
				.catch(err => {});
		},
		languageList() {
			let separ = [];
			for (let i in this.selectParams) {
				console.log(i, this.selectParams[i]);
				separ.push({ param: i, paramVal: this.selectParams[i] });
			}
			this.$axios({
				url: this.HOST + '/admin.setting/languageList',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token,
					sort_param: this.sort_param,
					sort_type: this.sort_type,
					selectParams: separ
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						if (res.data.admin_err == 'admininfo_error') {
							this.$message.error(res.data.msg);
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.langList = res.data.list;
						let that = this;
						// this.rowDrop(that); // 行拖拽排序
					}
				})
				.catch(err => {});
		},
		selectChange(selection) {
			console.log(selection);
			let arr = [];
			for (let i in selection) {
				arr.push(selection[i].lan_id);
			}
			this.selectedLngIds = arr;
			console.log(this.selectedLngIds);
		},
		addLanguage(scope) {
			console.log(scope);
			if (!scope) {
				this.addScope = {
					lng:'',
					lngtitle:'',
					packname:'',
					ispack:0
				};
			} else {
				this.addScope = JSON.parse(JSON.stringify(scope));
			}
			this.dialogVisible = true;
		},
		submitRuleForm(formname) {
			this.$refs[formname].validate((valid, attr) => {
				if (valid) {
					this.addSubmit();
				} else {
					console.log('error submit!!', attr);
					return false;
				}
			});
		},
		addSubmit() {
			this.$confirm('确定提交？')
				.then(() => {
					this.$axios({
						url: this.HOST + '/admin.setting/addLanguage',
						method: 'post',
						data: {
							adminid: JSON.parse(this.$store.state.user.userInfo).id,
							token: JSON.parse(this.$store.state.user.userInfo).token,
							langInfo: this.addScope
						}
					})
						.then(res => {
							console.log(res.data);
							if (res.data.status == 0) {
								this.$message.error(res.data.msg);
								if (res.data.admin_err == 'admininfo_error') {
									this.exit().then(res => {
										console.log(res);
										if (res.actionStatus == 1) {
											this.$router.push('/login');
										}
									});
								}
							} else {
								this.dialogVisible = false;
								this.$message.success(res.data.msg);
								this.languageList();
							}
						})
						.catch(err => {});
				})
				.catch(() => {
					console.log('取消');
				});
		},
		// 上传图片
		chooseIcon(){
			this.$refs.piclist.show();
		},
		chooseIconConfirm(e){
			console.log(e);
			this.addScope.pic = e.files;
		},
		delAdscopeImg() {
			this.addScope.pic = '';
			this.addScope[this.fileType[this.addScope.adtype - 1]] = '';
		},
		canCheck(row,index){
			if(row.lockin == 1){
				return false;
			}else{
				return true;
			}
		},
	}
};
</script>
<style lang="scss">
.el-main {
	padding: 0;
	.navpage {
		min-height: calc(100vh - 161px);
		.aside-primary {
			width: 240px;
			height: 100%;
			background-color: #ecf5ff;
			// height: 100%;
			padding: 20px;
			.el-divider__text {
				background-color: #ecf5ff;
				padding: 0 2px;
				font-size: 13px;
			}
			.el-menu-parent {
				background-color: transparent;
				.el-submenu {
					margin-bottom: 10px;
					background-color: #fff;
				}
				.el-menu-item {
					height: 45px;
					line-height: 45px;
					margin-bottom: 10px;
					background-color: #fff;
					min-width: 180px;
				}
			}
		}
		.width240 {
			width: 240px !important;
			transition: 0.8s;
		}
		.width0 {
			width: 0 !important;
		}
		.color-green {
			color: green;
		}
		.color-red {
			color: #ff2f4b;
		}
		.el-dropdown {
			margin: 0 10px;
		}
		.el-button + .el-button-group {
			margin-left: 10px;
		}
	}
}
</style>
